import {useMemo} from 'react';
import {BUTTONS_STYLES_OPTIONS, type GuestappThemeProps} from '@chekin/core';

interface TailwindVariables {
  [key: string]: string | undefined;
}
export function useTailwindThemeMapper(
  customTheme: GuestappThemeProps,
): TailwindVariables {
  return useMemo(() => {
    const variables: TailwindVariables = {};

    if (!customTheme || !customTheme.colors) {
      return variables;
    }

    if (customTheme.buttons.typeRadioButton) {
      variables['button-border-radius'] =
        customTheme.buttons.typeRadioButton === BUTTONS_STYLES_OPTIONS.round
          ? '50px'
          : '7px';
    }
    if (customTheme.colors.branding) {
      const {branding} = customTheme.colors;

      if (branding.primary) {
        variables['brand-color'] = branding.primary;
        variables['primary'] = branding.primary;
      }

      if (branding.icons) {
        variables['brand-icons'] = branding.icons;
      }

      if (branding.fontPrimary) {
        variables['font-primary'] = branding.fontPrimary;
        variables['button-secondary-foreground'] = branding.fontPrimary;
      }

      if (branding.fontSecondary) {
        variables['font-secondary'] = branding.fontSecondary;
      }

      if (branding.backgroundMain) {
        variables['background-main'] = branding.backgroundMain;
        variables['background'] = branding.backgroundMain;
      }

      if (branding.backgroundSecondary) {
        variables['background-secondary'] = branding.backgroundSecondary;
      }

      if (branding.boxesModals) {
        variables['card'] = branding.boxesModals;
        variables['popover'] = branding.boxesModals;
        variables['background-boxes-modals'] = branding.boxesModals;
        variables['modal-background'] = branding.boxesModals;
      }
    }

    if (customTheme.colors.buttons) {
      const {buttons} = customTheme.colors;

      if (buttons.textButton) {
        variables['text-button-color'] = buttons.textButton;
      }

      if (buttons.mainButtonBackground) {
        variables['button-primary-background'] = buttons.mainButtonBackground;
      }

      if (buttons.mainButtonTextBackground) {
        variables['button-primary-text-icon'] = buttons.mainButtonTextBackground;
      }

      if (buttons.secondaryButtonTextAndBorder) {
        variables['button-secondary'] = buttons.secondaryButtonTextAndBorder;
        variables['button-secondary-text'] = buttons.secondaryButtonTextAndBorder;
      }

      if (buttons.secondaryButtonBackground) {
        variables['button-secondary-background'] = buttons.secondaryButtonBackground;
      }
    }

    if (customTheme.colors.navigationMenu) {
      const {navigationMenu} = customTheme.colors;

      if (navigationMenu.backgroundMenu) {
        variables['navigation-background'] = navigationMenu.backgroundMenu;
      }

      if (navigationMenu.menuItemsText) {
        variables['navigation-item-text'] = navigationMenu.menuItemsText;
      }

      if (navigationMenu.selectedItemBackground) {
        variables['navigation-item-background-selected'] =
          navigationMenu.selectedItemBackground;
      }

      if (navigationMenu.selectedItemText) {
        variables['navigation-item-text-selected'] = navigationMenu.selectedItemText;
      }
    }

    if (customTheme.colors.splash) {
      const {splash} = customTheme.colors;

      if (splash.backgroundColor) {
        variables['splash-background'] = splash.backgroundColor;
      }

      if (splash.animationColor) {
        variables['splash-animation'] = splash.animationColor;
      }
    }

    if (customTheme.fonts) {
      const fonts = customTheme.fonts;
      if (fonts?.fontFamily?.titles) {
        variables['title-font-family'] = fonts.fontFamily.titles.font_name;
      }
      if (fonts?.fontFamily?.body) {
        variables['body-font-family'] = fonts.fontFamily.body.font_name;
      }
      if (fonts?.fontWeight) {
        variables['regular-font-weight'] = fonts.fontWeight.regular;
        variables['medium-font-weight'] = fonts.fontWeight.medium;
        variables['large-font-weight'] = fonts.fontWeight.mediumL;
        variables['bold-font-weight'] = fonts.fontWeight.bold;
      }
      if (fonts?.sizes) {
        variables['xs-font-size'] = fonts.sizes.smallX;
        variables['s-font-size'] = fonts.sizes.small;
        variables['m-font-size'] = fonts.sizes.medium;
        variables['l-font-size'] = fonts.sizes.large;
      }
    }

    return variables;
  }, [customTheme]);
}
